import Layout from './Layout';
import useResponsive from '../../shared/utils/Responsive';
import EmployeeLoginForm from './EmployeeLoginForm';
import EmployeeSmallScreen from './EmployeeSmallScreen';
const EmployeeUserLogin = () => {
    const isSmallScreen = useResponsive("md")
    return (
        <>
            {
                !isSmallScreen && (
                    <Layout text={"Employee login to continue your work journey."}>
                        <EmployeeLoginForm />
                    </Layout>
                )
            }
            {
                isSmallScreen && <EmployeeSmallScreen tabPage={0} />
            }

        </>

    )
}
export default EmployeeUserLogin
















